module.exports = __webpack_public_path__ + "img/Selector Bubble.1b51ede9.svg";